<template>
  <div class="ticket-card-detail">
    <span><strong>Описание</strong></span>
    <div class="comment" v-html="ticket.COMMENT"></div>
    <div v-if="isNotEmptyDocuments" cols="12" class="mt-2">
      <div><strong>Приложенный файл:</strong></div>
      <a :href="fileUrl" class="ticket-card-detail__image" target="_blank">
        <img v-if="isImageFile" :src="fileUrl" />
        <b-icon-paperclip
          class="ticket-card-detail__file-icon"
          :style="{ fontSize: '3rem' }"
          v-else
        />
        <span>{{ fileFormat }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("tickets", ["ticket", "loading"]),

    isNotEmptyDocuments() {
      return this.ticket.FILE.length > 0;
    },

    isImageFile() {
      const imageFormat = ["gif", "png", "jpeg", "jpg"];
      return imageFormat.some((format) => format === this.fileFormat);
    },

    fileFormat() {
      return this.ticket.FILE.split(".").pop().toLowerCase();
    },

    fileUrl() {
      return this.ticket.FILE.replace(
        "/var/www/www-root/data/www/",
        "https://"
      );
    },
  },
};
</script>
